var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "207", height: "218", viewBox: "0 0 207 218", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M125.791 109l77.977 82.12c4.31 4.539 4.31 11.896 0 16.434l-6.687 7.043c-4.309 4.537-11.295 4.537-15.604 0L103.5 132.476l-77.977 82.12c-4.309 4.538-11.295 4.538-15.604 0l-6.687-7.042c-4.31-4.538-4.31-11.895 0-16.433L81.209 109 3.232 26.88c-4.31-4.539-4.31-11.896 0-16.434l6.687-7.043c4.309-4.537 11.295-4.537 15.604 0L103.5 85.524l77.977-82.12c4.309-4.538 11.295-4.538 15.604 0l6.687 7.042c4.31 4.538 4.31 11.895 0 16.433L125.791 109z", fill: "#EFEFEF", fillRule: "nonzero" })
  );
});